// @ts-check
import React from 'react';
import _ from 'lodash';
import { Components } from './Components';

/**
 *
 * @param {ModelComponentProps} props
 * @returns {JSX.Element}
 */
const ModelComponent = ({ model, value, hasError, onChange, isLoading }) => {
  const Component = _.isFunction(model.type) ? model.type : Components[model.type];

  if (Component) {
    return (<Component
      model={model}
      value={value}
      onChange={onChange}
      hasError={hasError}
      isLoading={isLoading}
    />);
  }
  return <div />;

};

export default React.memo(ModelComponent);
